import React from 'react';
import NavItem from './NavItem';
import {getUserRole} from '../../helpers/localStorage';
const NavItems = props => {
  const roles = getUserRole();

  return (
    <>
      {props.screens.map(screen => {
        return (
          <NavItem
            key={screen.title}
            navSize={props.navSize ? props.navSize : 'large'}
            icon={screen.icon}
            title={screen.title}
            screen={screen.screen}
            active={screen.title === props.parent}
            visible={screen.allowedRoles?.some(role => roles?.includes(role))}
          />
        );
      })}
    </>
  );
};

export default NavItems;
